import { ComponentType, FC } from 'react';

import { TripTypeEnum, VehicleType } from '@mopla/data-models';
import { ITransportDescriptor } from '@mopla/utils';

import BusIcon from '../../icons/bus.svg';
import BusWithPeopleIcon from '../../icons/busWithPeople.svg';
import PRODTIcon from '../../icons/prodt.svg';
import PRODT_Business from '../../icons/prodt_business.svg';
import PRODT_BusinessVan from '../../icons/prodt_business_van.svg';
import PRODT_Economy from '../../icons/prodt_economy.svg';
import PRODT_First from '../../icons/prodt_first.svg';
import RufbusIcon from '../../icons/rufbus.svg';
import SchoolIcon from '../../icons/SchoolFilled.svg';
import WalkIcon from '../../icons/walk.svg';

import { SymbolCircle, TIconSize } from './TravelTypeSymbols.styles';

interface IConfig {
	TransportIcon: ComponentType;
	testId: string;
}

const mapTransportTypeToConfig: Record<TripTypeEnum | VehicleType, IConfig> = {
	[TripTypeEnum.WALK]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.TRANSFER_WALK]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.LBT]: {
		TransportIcon: BusIcon,
		testId: 'travelType-symbols-lbt',
	},
	[TripTypeEnum.LBODT]: {
		TransportIcon: RufbusIcon,
		testId: 'travelType-symbols-lbodt',
	},
	[TripTypeEnum.LBODTFLEX]: {
		TransportIcon: BusWithPeopleIcon,
		testId: 'travelType-symbols-lbodtFlex',
	},
	[TripTypeEnum.PRODT]: {
		TransportIcon: PRODTIcon,
		testId: 'travelType-symbols-prodt',
	},

	/** Those are added for the compatibility reasons, so every enum's option has a default render icon */
	[TripTypeEnum.OTHERS]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.BLOCKER]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.EMPTY]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.SPECIAL_SCHOOL_TRAFFIC]: {
		TransportIcon: SchoolIcon,
		testId: 'travelType-symbols-specialSchoolTraffic',
	},
	[TripTypeEnum.LBODTDS]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.POOLODT]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},
	[TripTypeEnum.UNCATEGORIZED]: {
		TransportIcon: WalkIcon,
		testId: 'travelType-symbols-walk',
	},

	[VehicleType.ECONOMY]: {
		TransportIcon: PRODT_Economy,
		testId: 'travelType-symbols-prodt_ECONOMY',
	},
	[VehicleType.BUSINESS]: {
		TransportIcon: PRODT_Business,
		testId: 'travelType-symbols-prodt_BUSINESS',
	},
	[VehicleType.BUSINESS_VAN]: {
		TransportIcon: PRODT_BusinessVan,
		testId: 'travelType-symbols-prodt_BUSINESS_VAN',
	},
	[VehicleType.FIRST_CLASS]: {
		TransportIcon: PRODT_First,
		testId: 'travelType-symbols-prodt_FIRST_CLASS',
	},
};

export interface ITransportCircleProps extends ITransportDescriptor {
	className?: string;
	variant?: 'midGrey' | 'main' | 'disabled';
	size?: TIconSize;
}

export const TransportCircle: FC<ITransportCircleProps> = ({
	className,
	transportType,
	vehicleType,
	variant = 'main',
	size = 'small',
}) => {
	const { TransportIcon, testId } =
		mapTransportTypeToConfig[vehicleType || transportType];

	return (
		<SymbolCircle
			className={className}
			ownerState={{ variant, size }}
			data-testid={testId}
		>
			<TransportIcon />
		</SymbolCircle>
	);
};
